import {
	type FindAuthenticationOptionsResponse,
	type FindRegistrationOptionsResponse,
	type Passkey,
	type PasskeyRepository,
	PlatformOptions,
	type TokenPair
} from '@contexts/auth/domain';
import type {
	EnvironmentRepository,
	GetResponse,
	HttpService,
	WebAuthnAuthenticationAssertion,
	WebAuthnRegistrationCredential
} from '@contexts/shared/domain';

export function restApiPasskeyRepositoryBuilder(
	environment: EnvironmentRepository,
	httpService: HttpService
): PasskeyRepository {
	return {
		async findRegistrationOptions(): Promise<FindRegistrationOptionsResponse> {
			const response = await httpService.post<FindRegistrationOptionsResponse>(
				`${environment.apiBaseUrl}/auth/passkeys/register/options`,
				{}
			);
			return response.data;
		},
		async register(
			token: string,
			name: string,
			options: WebAuthnRegistrationCredential
		): Promise<void> {
			await httpService.post<{ token: string }>(
				`${environment.apiBaseUrl}/auth/passkeys/register/verify`,
				{
					token,
					name,
					response: options
				},
				{
					responseType: 'text'
				}
			);
		},
		async findAuthenticationOptions(token: string): Promise<FindAuthenticationOptionsResponse> {
			const response = await httpService.post<FindAuthenticationOptionsResponse>(
				`${environment.apiBaseUrl}/auth/passkeys/authenticate/options`,
				{ token }
			);
			return response.data;
		},
		async authenticate(
			token: string,
			rememberMe: boolean,
			options: WebAuthnAuthenticationAssertion
		): Promise<TokenPair> {
			const response = await httpService.post<TokenPair>(
				`${environment.apiBaseUrl}/auth/passkeys/authenticate/verify`,
				{
					token,
					rememberMe,
					platform: PlatformOptions.WEB,
					authenticationResponse: options
				},
				undefined
			);

			return response.data;
		},
		async findAllPasskeysByUserId(): Promise<Passkey[]> {
			const response = await httpService.get<Passkey[]>(
				`${environment.apiBaseUrl}/auth/passkeys`
			);
			return response.data;
		},
		async deletePasskey(id: string): Promise<string> {
			const response = await httpService.delete<string>(
				`${environment.apiBaseUrl}/auth/passkeys/${id}`
			);

			return response.data;
		}
	};
}
